import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Building2, Users, Briefcase, ShieldCheck } from 'lucide-react';
import { OrgOverviewTab } from './OrgOverviewTab';
import { OrgMembersPanel } from './OrgMembersPanel';
import { OrgWorkspacesPanel } from './OrgWorkspacesPanel';
import { OrgEntitlementsTab } from './OrgEntitlementsTab';
import type { Organization } from '@/types/database';

interface OrgDetailsProps {
  organization: Organization;
  onRefresh: () => void;
}

export const OrgDetails: React.FC<OrgDetailsProps> = ({
  organization,
  onRefresh,
}) => {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="overview" className="w-full">
        <TabsList className="w-full sm:w-auto grid grid-cols-2 sm:grid-cols-4">
          <TabsTrigger value="overview">
            <Building2 className="w-4 h-4 mr-2 hidden sm:inline" />
            Overview
          </TabsTrigger>
          <TabsTrigger value="members">
            <Users className="w-4 h-4 mr-2 hidden sm:inline" />
            Members
          </TabsTrigger>
          <TabsTrigger value="workspaces">
            <Briefcase className="w-4 h-4 mr-2 hidden sm:inline" />
            Workspaces
          </TabsTrigger>
          <TabsTrigger value="entitlements">
            <ShieldCheck className="w-4 h-4 mr-2 hidden sm:inline" />
            Entitlements
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="mt-6">
          <OrgOverviewTab organization={organization} onRefresh={onRefresh} />
        </TabsContent>

        <TabsContent value="members" className="mt-6">
          <OrgMembersPanel orgId={organization.id} />
        </TabsContent>

        <TabsContent value="workspaces" className="mt-6">
          <OrgWorkspacesPanel orgId={organization.id} />
        </TabsContent>

        <TabsContent value="entitlements" className="mt-6">
          <OrgEntitlementsTab
            orgId={organization.id}
            orgName={organization.name}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
